import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 text-center p-6">
      <h1 className="text-6xl font-bold text-font-minimal">404</h1>
      <p className="text-xl text-font-subtle">{t("Common.notFound.title")}</p>
      <button
        className="mt-4 px-6 py-2 rounded-md text-font-inverted bg-background-primary hover:opacity-90 transition-opacity cursor-pointer"
        onClick={() => navigate("/", { replace: true })}
      >
        {t("Common.notFound.goHome")}
      </button>
    </div>
  );
}
